import './modifyLimitStep1.scss';

import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { i18n } from 'core/i18n';
import { connect } from 'react-redux';
import * as cardChangePaymentMethodActions from 'actions/cardChangePaymentMethod';
import * as hireCreditLimitActions from 'actions/hireCreditLimit';
import * as cardModifyNewLimitActions from 'actions/cardModifyNewLimit/cardModifyNewLimit';
import * as  revolvingActions from 'actions/cardRevolvingDocuments';
import CardModifyLimitInformativeSection from 'components/cards/cardModifyLimit/cardModifyLimitInformativeSection/cardModifyLimitInformativeSection';
import HireNewCreditLimit from 'components/hire/hireCreditLimit/hireNewCreditLimit';
import { OKCheckbox } from 'commonsComponents/OKCheckbox';
import bannerImage from 'assets/images/cards/creditCardBanner.png';
import { getCardType } from 'utilities/cardsHelper';
import BlockInfo from 'components/contactCenter/blockInfo/blockInfo';
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';
import { NOT_MAX_LIMIT, NA } from 'constants/index';
import { recordLinkV2 } from 'utilities/tagging';

const ModifyNewLimitStep1 = (props) => {
    const {
        immCard,
        requestPaymentMethodInfo,
        immCardModifyLimit,
        immHireCreditLimit,
        toggleCreditLimitModal,
        immHirePaymentMethod,
        immPdfRevolvingPersistent,
        handleCreditLimitChange,
        handleCreditLimitModalValueChange,
        handleToggleModal,
        getHiring,
        defaultLimit,
        immGlobalVariables,
        setInneParams,
        setAFIParams,
        isCheckboxCheckedStep1,
        setIsCheckboxCheckedStep1,
        setIsCheckboxChecked,
        isCheckboxChecked,
        setMaxAmountDisabled,
        minimumlimit,
        setMinimumlimit,
        setNotLimit,
        getCustomTags,
        pageName = '',
    } = props
    const { FormattedText } = i18n;
    const amount = immCard.getIn(['limit', 'amount'])
    const titleKey = immCard.get('isViaT') ? 'cardModifyLimitInformativeSection-stepOneTitleViaT' : 'cardModifyLimitInformativeSection-stepOneTitle';
    const maximumLimitAuthorize = immHireCreditLimit.get('maximumLimitAuthorize');
    const maxPreaprovedValue = immHireCreditLimit.get('maxValue');

    const sliderMarks = immHireCreditLimit.get('marks');
    const creditLimit = !isCheckboxChecked && __CONTACT_CENTER__ && !isPrintOfficeMode() && immHireCreditLimit.get('creditLimit') === NOT_MAX_LIMIT
        ? sliderMarks.get(0)
        : (immHireCreditLimit.get('creditLimit') === NOT_MAX_LIMIT ? sliderMarks.get(0) : immHireCreditLimit.get('creditLimit'));
    const confirmationAgentLabel = <FormattedText value="cc_hireNewCreditCard-confirmationAgentLabel" />
    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        setIsCheckboxCheckedStep1(checked);
        setIsCheckboxChecked(checked);
    };
    useEffect(() => {
        setMaxAmountDisabled(immHireCreditLimit.get('maximumLimitAuthorize') === NOT_MAX_LIMIT && immHireCreditLimit.get('creditLimit') != sliderMarks.get(0))

        if (sliderMarks) {
            const sliderMarksOneElement = sliderMarks.toJS().length
            setMinimumlimit(sliderMarks.get(0));

            if (sliderMarksOneElement === 1) {
                setNotLimit(true);
            }
        }
    }, [sliderMarks])
    useEffect(() => {
        setMaxAmountDisabled(immHireCreditLimit.get('maximumLimitAuthorize') === NOT_MAX_LIMIT && immHireCreditLimit.get('creditLimit') === amount)
    }, [immHireCreditLimit.get('creditLimit')])
    useEffect(() => {

        const type = immCard.get('newProduct');
        const subType = immCard.get('productSubType');
        const standard = immCard.getIn(['criteria', 'c1', 'estand']);
        const amount = immCard.getIn(['limit', 'amount'])
        const creditLimit = immHireCreditLimit.get('creditLimit');
        if (!creditLimit) {
            getHiring(type, subType, standard, defaultLimit, immCard.get('cardId'), amount);
        }
        const cardType = getCardType(immCard);
        const tin = getCardData(cardType, 'aplazado_tin');
        const tae = getCardData(cardType, 'aplazado_tae');
        const interestRate = Number(tin.replace(/%/g, '').replace(',', '.')) / 100;

        setInneParams({
            tin,
            tae
        });
        setAFIParams({
            interestRate,

        });
    }, []);

    useEffect(() => {
        return () => {
            requestPaymentMethodInfo(immCard.get('cardId'));
        };
    }, [requestPaymentMethodInfo]);

    const onCreditLimitModalContinue = () => {
        newSetHireCreditCardType(immHireCreditLimit.get('creditLimitModalValue'), true);
        toggleCreditLimitModal(false);
    };
    const getCardData = (creditType, type) => {
        const tintaeValues = {
            'OPEN_CREDIT_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', type]),
            'DIAMOND_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'pack_diamond', type]),
            'PREMIUM_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'pack_premium', type]),
            'VIAT_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'via-t', type]),
        };

        return tintaeValues[creditType];
    }
    
   const onChangeSlider = (creditLimit, resetModalValue) => {
        const tag = getCustomTags({ creditLimit, pageName}).clickSlider
        recordLinkV2(tag);
    }
    const onOpenSelectMenu = () => {
        const tag = getCustomTags({ pageName, status: 'open' }).clickDropdown;
        recordLinkV2(tag);
    }
    const onCloseSelectMenu = () => {
        const tag = getCustomTags({ pageName, status: 'close' }).clickDropdown;
        recordLinkV2(tag);
    }

    const onSelectChange = (creditLimit) => {
        const tag = getCustomTags({ amount: creditLimit, pageName }).selectAmount;
        recordLinkV2(tag);
    }

    return (
        <article className="modify-limit-step-one">
            <CardModifyLimitInformativeSection immCard={immCard} titleKey={titleKey} />
            {__CONTACT_CENTER__ && !isPrintOfficeMode() && maximumLimitAuthorize && maximumLimitAuthorize !== NOT_MAX_LIMIT ? (
                <>
                    <BlockInfo>
                        <p className="requiredReading">
                            <FormattedText value="cc_hireNewCreditCard-requiredReading" />
                        </p>
                        <FormattedText
                            value="cc_hireNewCreditCard-agentInformation_limitCredit_text_one"
                        />
                        <span> {maxPreaprovedValue}</span>
                        <FormattedText
                            value="cc_hireNewCreditCard-agentInformation_limitCredit_text_two"
                        />
                    </BlockInfo>
                    <OKCheckbox
                        idName="hireNewCreditCardAgentConfirmationStepOne"
                        label={confirmationAgentLabel}
                        onChange={handleCheckboxChange}
                        value={isCheckboxCheckedStep1}
                    />
                </>
            ) : null}
            <HireNewCreditLimit
                handleModalContinue={onCreditLimitModalContinue}
                immHireCreditLimit={immHireCreditLimit}
                immHirePaymentMethod={immHirePaymentMethod}
                productSubType={immCardModifyLimit.get('subtype')}
                productType={immCardModifyLimit.get('type')}
                referenceStandard={immCardModifyLimit.get('standard')}
                newSetCardLimit={true}
                bannerImage={bannerImage}
                immPdfRevolvingPersistent={immPdfRevolvingPersistent}
                handleCreditLimitChange={handleCreditLimitChange}
                onChangeSlider={onChangeSlider}
                onOpenSelectMenu={onOpenSelectMenu}
                onCloseSelectMenu={onCloseSelectMenu}
                onSelectChange={onSelectChange}
                handleCreditLimitModalValueChange={handleCreditLimitModalValueChange}
                handleToggleModal={handleToggleModal}
                newCreditLimit={immCard.getIn(['limit', 'amount'])}
                changeCreditLimitMessages={true}
                isCheckboxChecked={isCheckboxChecked}
                maximunNotLimit={maximumLimitAuthorize === NOT_MAX_LIMIT}
                creditLimit={creditLimit}
                minimumlimit={minimumlimit}
                amount={amount}
                disabledSlider={minimumlimit == amount && maximumLimitAuthorize === NOT_MAX_LIMIT}
                maximumLimitNoMessage={maximumLimitAuthorize === NA}
                getCustomTags={getCustomTags}
                pageName={pageName}
            />
        </article>
    );
}

module.exports.constructor = ModifyNewLimitStep1;
module.exports.ModifyNewLimitStep1 = connect(
    state => ({
        immHireCreditLimit: state.hireCreditLimit,
        immHirePaymentMethod: state.hirePaymentMethod,
        immPdfRevolvingPersistent: state.revolvingPersistentData,
        immGlobalVariables: state.globalVariables,
    }),
    {
        requestPaymentMethodInfo: cardChangePaymentMethodActions.requestPaymentMethodInfo,
        getHiring: cardModifyNewLimitActions.getHiring,
        toggleCreditLimitModal: hireCreditLimitActions.toggleModal,
        handleCreditLimitChange: hireCreditLimitActions.setHireCreditLimit,
        handleCreditLimitModalValueChange: hireCreditLimitActions.setHireCreditLimitModalValue,
        handleToggleModal: hireCreditLimitActions.toggleModal,
        setInneParams: revolvingActions.setInneParams,
        setAFIParams: revolvingActions.setAFIParams,
    }
)(withRouter(ModifyNewLimitStep1));




